import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Flex, Form, Select, Switch } from 'antd';

function MenuSubjectEntryScope({ update, isMaster, field, value }) {
  const { t } = useTranslation(undefined, { keyPrefix: `Modals:Product:ProductModal.form.${field}` });
  const companies = useSelector(
    (state) => state.currentCompany.company.franchise?.companies ?? state.currentFranchise.franchise?.companies,
  );
  const isAvailableOptions = companies.map((company) => ({ label: company.name, value: company.id }));

  return (
    <Form.Item label={isMaster ? t('label') : null}>
      {isMaster ? (
        <Select
          allowClear
          mode="multiple"
          showSearch={{ optionFilterProp: 'label' }}
          options={isAvailableOptions}
          value={value}
          onChange={(value) => update(field, value)}
        />
      ) : (
        <Flex>
          <Switch checked={value} onChange={(checked) => update(field, checked)} id={field} />
          <label htmlFor={field} className="ml-xs">
            {t('label')}
          </label>
        </Flex>
      )}
    </Form.Item>
  );
}

export default MenuSubjectEntryScope;
